import * as Sentry from "@sentry/react";

// Error reporting only. Performance tracing (browserTracingIntegration) and
// Session Replay (replayIntegration) were removed to cut ~100KB+ gzipped from
// the client bundle — chiefly @sentry-internal/replay — and keep us under the
// 2MB bundle-size gate. Both opt-in integrations add little value at pre-launch
// traffic (0 users); re-enable when there are real sessions to record/trace.
// Sentry's default integrations (global onerror + unhandledrejection capture,
// dedupe, etc.) remain active, so error reporting is unaffected.
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});
